import { Box,Chip } from '@material-ui/core'
import './amschip.css'

const AmsChip = (props: any) => {

    const {text, itemClick} = props
     
    const handleClick = () => {
        itemClick()
    }
    return (
        <Box className='chipBlock'>
            <Chip label={text} onClick={handleClick} className='chip'/>
        </Box>
    )
}

export default AmsChip